import { render, staticRenderFns } from "./rewardProgram.vue?vue&type=template&id=16a473ea&scoped=true&"
import script from "./rewardProgram.vue?vue&type=script&lang=js&"
export * from "./rewardProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a473ea",
  null
  
)

component.options.__file = "rewardProgram.vue"
export default component.exports